import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const EnumSetListView = ({ store }) => {
  if (!store.hasRight(store.router && store.router.params && linkConst.RIGHTS_UNDER[store.router.params.entityname])) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const DetailLink = ({ text }) => (<a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>)
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => (<TextField attr={attr} val={row[attr]} />)
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }
  const filters = {
    id_like: { title: 'ID', component: (props) => (<TextInput {...props} />) },
    value_like: { title: 'Key', component: (props) => (<TextInput {...props} />) },
    text_like: { title: 'Text', component: (props) => (<TextInput {...props} />) }
  }

  return (<ListView
    store={store.cv}
    batchActions={batchActions}
    fields={fields}
    filters={() => Filters(store, filters)}
    // helper={store.helpFor(store.router && store.router.params && store.router.params.entityname)}
    onAddClicked={store.addClicked.bind(store)} />
  )
}

export default observer(EnumSetListView)
